export const environment = {
  production: false,
  apiUrl: "https://casi-dev.une.edu.au/db-manager",
  socketUrl: "https://casi-dev.une.edu.au"
};
